// @packages
import { makeStyles } from '@rneui/themed';

export default makeStyles((theme) => ({
  container: {
    borderWidth: 1,
    width: '90%',
    margin: 10,
    padding: 10,
    borderRadius: 10,
    borderColor: 'white',
    backgroundColor: 'white'
  },
  listItem: {
    borderBottomColor: theme.colors.primary,
    borderBottomWidth: 1
  },
  firstColumn: {
    flex: 2
  },
  secondColumn: {
    flex: 1
  },
  title: {
    fontSize: 14
  }
}));
